import { getSelectValue } from "src/system/getSelectValue.ts";
import { getSelectLabel } from "src/system/getSelectLabel.ts";
import type { GridValidRowModel } from "@mui/x-data-grid-premium";
import type { SelectValueProp, SelectLabelProp } from "./system.types";
import { unique } from "@exonn/utils";
import { useMemo } from "react";

export const useSelectOptions = <
  Resource extends GridValidRowModel = GridValidRowModel,
>({
  valueProp,
  labelProp,
  resources,
  groupBy,
  groups,
}: {
  valueProp?: SelectValueProp<Resource>;
  labelProp?: SelectLabelProp<Resource>;
  resources: Resource[];
  groupBy?: string;
  groups?: {
    label: string;
    value: string;
  }[];
}) => {
  return useMemo(() => {
    if (groupBy) {
      const groups_ = unique(resources.map((resource) => resource[groupBy]));

      return groups_.map((group) => ({
        label: (groups || []).find((g) => g.value === group)?.label || group,
        value: group,
        options: resources
          .filter((resource) => resource[groupBy] === group)
          .map((resource) => {
            return {
              value: getSelectValue({
                item: resource,
                valueProp,
              }) as string,
              label: getSelectLabel<Resource>({
                item: resource,
                labelProp,
              }) as string,
              resource,
            };
          }),
      }));
    }
    return resources.map((resource) => ({
      value: getSelectValue({
        item: resource,
        valueProp,
      }) as string,
      label: getSelectLabel<Resource>({
        item: resource,
        labelProp,
      }) as string,
      resource,
    }));
  }, [resources, groupBy, groups, labelProp, valueProp]);
};
